var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html } from "lit";
import { property } from "lit/decorators.js";
import { documentCss } from "./styles.js";
import { QboFetchMixin, getArray, formatDate, qboui } from "@quandis/qbo4.ui";
import { QboTemplate, template } from "@quandis/qbo4.configuration";
export class QboDocument extends QboFetchMixin(QboTemplate) {
    constructor() {
        super(...arguments);
        this.apiEndpoint = new URL("api://qbo4/documents/document");
        this.display = 25;
        this.start = 0;
        this.docid = null;
        this.enableViewer = true;
        this.path = null;
        this.imagePath = window.qbo4['imagePath'] ?? '/ui/images/qbo-icons.svg';
        this.renderInHost = false;
        this.searchFilter = false;
        this.show = true;
        this.showInline = false;
        this.summaryFocus = 'select';
        this.type = 'search';
        this.viewDocument = null;
        this.uniqueId = `e${Math.random().toString(36).substring(2, 9)}`;
    }
    static { this.styles = [
        qboui,
        documentCss
    ]; }
    async connectedCallback() {
        if (Object.keys(this.dataset).length > 0)
            this.payload = { ...this.dataset };
        switch (this.type) {
            case "search":
                this.apiEndpoint = new URL("api://qbo4/documents/document/search");
                break;
            case "searchSimple":
                this.apiEndpoint = new URL("api://qbo4/documents/document/search");
                break;
        }
        super.connectedCallback();
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    createRenderRoot() {
        return this.renderInHost ? this : super.createRenderRoot();
    }
    filterKeyDown(e) {
        this.filterData = null;
        this.shadowRoot?.querySelectorAll('tr.qbo-filter').forEach(tr => {
            tr.querySelectorAll('input').forEach(input => {
                if (input instanceof HTMLInputElement && input.value.trim() != '') {
                    if (!this.filterData)
                        this.filterData = {};
                    this.filterData[input.name] = input.value;
                }
            });
        });
    }
    view(document, e) {
        e.preventDefault();
        if (this.showInline)
            this.viewDocument = document;
        this.dispatchEvent(new CustomEvent('qbo-documents-add', {
            detail: {
                title: document.Attachment,
                render: html `<qbo-document type="summary" apiendpoint="api://qbo4/documents/document/summary/${document.AttachmentID}"></qbo-document>`
                //    render: () => {
                //        console.log(`${document.AttachmentID}`);
                //        return html`Doc ${document.AttachmentID}: <qbo-document type="summary" apiendpoint="api://qbo4/documents/document/summary/${document.AttachmentID}"></qbo-document>`;
                //    }
            },
            bubbles: true,
            composed: true
        }));
    }
    handleFileDrop(e) {
    }
    async paginate(e) {
        if (this.payload == null)
            this.payload = {};
        this.payload['DisplaySize'] = e.detail['display'];
        this.payload['RecordStart'] = e.detail['start'];
        const currentDisplay = this.display;
        this.display = Number(this.payload['DisplaySize']);
        const currentStart = this.start;
        this.start = Number(this.payload['RecordStart']);
        const count = Number(getArray(this.jsonData)?.[0]?.RecordCount) || 0;
        if (count > 0 && (currentDisplay != this.display || currentStart != this.start))
            await this.fetchData(this.headers ?? {}, this.payload);
    }
    renderContextMenu(component) {
        return html `<qbo-menu type="context" target="#${this.uniqueId}">
<menu>
    <li>Copy</li>
    <li>Cut</li>
    <li>Paste</li>
    <li>Delete</li>
    <li>OCR</li>
    <li>Classify</li>
    <li>Transcribe</li>
    <li>Extract</li>
    <li>Zip and Download</li>
    <li>Zip and Email</li>
</menu>
        </qbo-contextmenu>`;
    }
    async updatePayload(event) {
        const payload = event.detail?.payload;
        if (payload) {
            this.payload = payload;
            await this.fetchData(this.headers, this.payload);
        }
    }
    renderFocus() {
        if (!this.jsonData || Object.keys.length === 0)
            return html `Loading...`;
        switch (this.summaryFocus) {
            case 'parent':
                const parent = this.jsonData?.Root?.AttachmentItem.Object;
                return this.parent(this.jsonData?.Root[`${parent}Item`] ?? { Parent: 'None' });
            case 'score':
                const metadata = this.jsonData?.Root?.ScoreItemItem;
                return this.metadata(metadata);
            default: return this.select(this.jsonData?.Root?.AttachmentItem);
        }
    }
    search(component) {
        const json = getArray(component.jsonData);
        const count = Number(json?.[0]?.RecordCount) || json?.length || 0;
        const length = json?.length || 0;
        const jsonPage = length > component.display ? json?.slice(component.start, component.start + component.display) : json;
        return html `<slot class=${component.show ? '' : 'collapse'}><qbo-file multiple="true" url="/documents/document/upload" .path=${component.path} .payload=${component.payload} class="container">
<h3 class="title">
    <button type="button" class="expandcollapse" @click="${(e) => component.show = !component.show}">
        <svg>
            <use href="${component.imagePath}#${component.show ? 'dash' : 'plus'}">
        </svg>
    </button>
    Document Center
</h3>
<div class="qbo-row-viewer">
    <div class="qbo-col qbo-col-noborder">
        <table class="qbo-nowrap" data-drop>
            <thead>
                <tr>
                    <th>
                        <qbo-selectable parent="table"></qbo-selectable>
                        <qbo-table-sort></qbo-table-sort>
                    </th>
                    <th data-sort>Document<qbo-search .payload=${component.payload} @change=${component.updatePayload}></qbo-search></th>
                    <th>Type</th>
                    <th data-sort>Format</th>
                    <th data-sort>Parent</th>
                    <th data-sort>Parent Num</th>
                    <th data-sort="date">Created Date</th>
                    <th data-sort>Created By</th>
                    <th data-qbo-file-click>Labels</th>
                </tr>
            </thead>
            <tbody id="${component.uniqueId}">
                ${jsonPage ? jsonPage.map(item => html `
                    <tr data-selectable="${item.AttachmentID}">
                        <td><input type="checkbox" id="${item.AttachmentID}"></td>
                        <td><a href="/api/attachment/${item.AttachmentID}" @click=${(e) => component.view(item, e)}>${item.Attachment}</a></td>
                        <td>${item.AttachmentType}</td>
                        <td>${item.MimeType}</td>
                        <td>${item.Object}</td>
                        <td>${item.ParentLabel}</td>
                        <td>${formatDate(item.CreatedDate)}</td>
                        <td>${item.CreatedPerson}</td>
                        <td></td>
                    </tr>
                `) : html `<tr><td colspan="9">No data available</td></tr>`}
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="9" class="progress-wrapper">${json && json[0] ? html `<qbo-paginate count="${count}" @change=${(e) => component.paginate(e)}></qbo-paginate>` : html ``}<progress class="progress-bar" data-qbo-file-progress max="100" value="0"></progress></td>
                </tr>
            </tfoot>
            <caption>${component.renderContextMenu(component)}</caption>
        </table>
    </div>
${component.viewDocument && component.enableViewer ? html `<qbo-resize></qbo-resize>
    <div class="qbo-col qbo-col-noborder">
        <qbo-document-viewer .document=${component.viewDocument} mimeType="text/plain" @close="${(e) => component.viewDocument = null}"></qbo-document-viewer>
    </div>` : html ``}
</div></qbo-file></slot>`;
    }
    searchSimple(component) {
        let json = getArray(component.jsonData) ?? [];
        if (component.filterData) {
            json = json
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.Attachment) {
                    return item.Attachment?.toLowerCase().includes(component.filterData.Attachment.toLowerCase());
                }
                return true;
            })
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.Date) {
                    return formatDate(item.CreatedDate)?.toLowerCase().includes(component.filterData.Date.toLowerCase());
                }
                return true;
            })
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.Time) {
                    return formatDate(item.CreatedDate, 'HH:mm:ss')?.toLowerCase().includes(component.filterData.Time.toLowerCase());
                }
                return true;
            })
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.User) {
                    return item.CreatedPerson?.toLowerCase().includes(component.filterData.User.toLowerCase());
                }
                return true;
            })
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.Module) {
                    return item.Object?.toLowerCase().includes(component.filterData.Module.toLowerCase());
                }
                return true;
            })
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.Name) {
                    return item.ParentLabel?.toLowerCase().includes(component.filterData.Name.toLowerCase());
                }
                return true;
            });
        }
        const count = Number(json?.[0]?.RecordCount) || json?.length || 0;
        const length = json?.length || 0;
        const jsonPage = length > component.display ? json?.slice(component.start, component.start + component.display) : json;
        return html `<slot class=${component.show ? '' : 'collapse'}>
<h3 class="title">
    <button type="button" class="expandcollapse" @click="${(e) => component.show = !component.show}">
        <svg>
            <use href="${component.imagePath}#${component.show ? 'dash' : 'plus'}">
        </svg>
    </button>
    Document Center
</h3>
<div class="qbo-row-viewer">
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-card-buttons">
            <button type="button" class="${component.searchFilter ? 'active' : ''}" @click="${(e) => component.searchFilter = !component.searchFilter}">
                <svg>
                    <use href="${component.imagePath}#search">
                </svg>
                Search
                <qbo-popover>
                    <h3>Search</h3>
                    <p>Toggle the search options to locate specific documents.</p>
                </qbo-popover>
            </button>
        </div>
        <table class="qbo-nowrap">
            <thead>
                <tr>
                    <th data-sort>Document</th>
                    <th data-sort="date">Date</th>
                    <th data-sort="time">Time</th>
                    <th data-sort>User</th>
                    <th data-sort>Module</th>
                    <th data-sort>Name</th>
                </tr>
            </thead>
            <tbody id="${component.uniqueId}">
                ${component.searchFilter ? html `
                    <tr class="qbo-filter">
                        <td><input type="text" name="Attachment" @keyup=${component.filterKeyDown}></input></td>
                        <td><input type="text" name="Date" @keyup=${component.filterKeyDown}></input></td>
                        <td><input type="text" name="Time" @keyup=${component.filterKeyDown}></input></td>
                        <td><input type="text" name="User" @keyup=${component.filterKeyDown}></input></td>
                        <td><input type="text" name="Module" @keyup=${component.filterKeyDown}></input></td>
                        <td><input type="text" name="Name" @keyup=${component.filterKeyDown}></input></td>
                    </tr>
                ` : html ``}
                ${jsonPage ? jsonPage.map(item => html `
                    <tr>
                        <td><a href="/api/attachment/${item.AttachmentID}" @click=${(e) => component.view(item, e)}>${item.Attachment}</a></td>
                        <td>${formatDate(item.CreatedDate)}</td>
                        <td>${formatDate(item.CreatedDate, 'HH:mm:ss')}</td>
                        <td>${item.CreatedPerson}</td>
                        <td>${item.Object}</td>
                        <td>${item.ParentLabel}</td>
                    </tr>
                `) : html `<tr><td colspan="9">No data available</td></tr>`}
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="6" class="progress-wrapper">${jsonPage && jsonPage[0] ? html `<qbo-paginate count="${count}" @change=${(e) => component.paginate(e)}></qbo-paginate>` : html ``}<progress class="progress-bar" data-qbo-file-progress max="100" value="0"></progress></td>
                </tr>
            </tfoot>
        </table>
    </div>
${component.viewDocument && component.enableViewer ? html `<qbo-resize></qbo-resize>
    <div class="qbo-col qbo-col-noborder">
        <qbo-document-viewer .document=${component.viewDocument} mimeType="text/plain" @close="${(e) => component.viewDocument = null}"></qbo-document-viewer>
    </div>` : html ``}
</div></slot>`;
    }
    adDocumentTab() {
    }
    parent(parent) {
        const element = `qbo-${parent}`;
        return (customElements.get(element) === undefined)
            ? html `<header>Parent Details</header>
<div class="qbo-form">
${Object.keys(parent).map(key => {
                return html `<label>${key}</label><span>${parent[key]}</span>`;
            })}
</div>`
            : html `<qbo-${parent} type="select"></qbo-${parent}>`;
    }
    metadata(items) {
        return html `<header>Document Metadata</header>
<div class="qbo-form">
    ${items?.map(item => {
            return html `
    <label>${item?.ScoreItemTemplate}</label>
    <span>${item?.ScoreMoney ?? item.ScoreInt ?? item.ScoreFloat ?? item.ScoreBoolean ?? item.ScoreChar ?? item.ScoreDate}</span>
    `;
        })}
</div>`;
    }
    select(document) {
        return html `<header>Document Details</header>
<div class="qbo-form">
    <label>Document</label>
    <span>${document?.Attachment}</span>
    <label>Type</label>
    <span>${document?.AttachmentType}</span>
    <label>Status</label>
    <span>${document?.Status}</span>
    <label>Created</label>
    <span>${formatDate(document?.CreatedDate)}</span>
    <label>By</label>
    <span>${document?.CreatedPerson}</span>
    <label>Updated</label>
    <span>${formatDate(document?.UpdatedDate)}</span>
    <label>By</label>
    <span>${document?.UpdatedPerson}</span>
</div>`;
    }
    summary(component) {
        const document = component.jsonData?.Root?.AttachmentItem || { Attachment: 'Loading...' };
        component.viewDocument = (document.AttachmentID) ? document : null;
        return html `<div class="qbo-row">
        <menu class="qbo-toolbar vertical">
            <li title="Document"><a @click=${(e) => component.summaryFocus = "select"}><qbo-icon icon="document"></qbo-icon></a></li>
            <li title="Metadata"><a @click=${(e) => component.summaryFocus = "score"}><qbo-icon icon="score"></qbo-icon></a></li>
            <li title="Parent"><a @click=${(e) => component.summaryFocus = "parent"}><qbo-icon icon="arrow-90deg-up"></qbo-icon></a></li>
            <li title="Viewer"><a @click=${(e) => component.enableViewer = !component.enableViewer}><qbo-icon icon="search"></qbo-icon></a></li>
        </menu>
    <div class="qbo-card">
    ${component.renderFocus()}
    </div>
    ${component.viewDocument && component.enableViewer ? html `<qbo-resize></qbo-resize>
    <div class="qbo-col"><qbo-document-viewer .document=${component.viewDocument} mimeType="text/plain" @close="${(e) => component.viewDocument = null}"></qbo-document-viewer></div>` : html ``}
</div>`;
    }
}
__decorate([
    property({ type: URL }),
    __metadata("design:type", Object)
], QboDocument.prototype, "apiEndpoint", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Object)
], QboDocument.prototype, "display", void 0);
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], QboDocument.prototype, "filterData", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Object)
], QboDocument.prototype, "start", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboDocument.prototype, "docid", void 0);
__decorate([
    property(),
    __metadata("design:type", Boolean)
], QboDocument.prototype, "enableViewer", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboDocument.prototype, "path", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboDocument.prototype, "imagePath", void 0);
__decorate([
    property(),
    __metadata("design:type", Boolean)
], QboDocument.prototype, "renderInHost", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboDocument.prototype, "searchFilter", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboDocument.prototype, "show", void 0);
__decorate([
    property(),
    __metadata("design:type", Boolean)
], QboDocument.prototype, "showInline", void 0);
__decorate([
    property(),
    __metadata("design:type", String)
], QboDocument.prototype, "summaryFocus", void 0);
__decorate([
    property(),
    __metadata("design:type", String)
], QboDocument.prototype, "type", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboDocument.prototype, "viewDocument", void 0);
__decorate([
    template('contextmenu'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboDocument]),
    __metadata("design:returntype", void 0)
], QboDocument.prototype, "renderContextMenu", null);
__decorate([
    template('search'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboDocument]),
    __metadata("design:returntype", void 0)
], QboDocument.prototype, "search", null);
__decorate([
    template('searchSimple'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboDocument]),
    __metadata("design:returntype", void 0)
], QboDocument.prototype, "searchSimple", null);
__decorate([
    template('parent'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], QboDocument.prototype, "parent", null);
__decorate([
    template('metadata'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], QboDocument.prototype, "metadata", null);
__decorate([
    template('select'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], QboDocument.prototype, "select", null);
__decorate([
    template('summary'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboDocument]),
    __metadata("design:returntype", void 0)
], QboDocument.prototype, "summary", null);
if (!customElements.get('qbo-document'))
    customElements.define('qbo-document', QboDocument);
